import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Route, Switch, HashRouter } from "react-router-dom";

import { ask__ } from './../../shared/utils/i18n.js';
import { findClient } from './../../shared/utils/api.js';
import { fetchLoginStatus } from './../../shared/utils/auth.js';
import { getWebsiteApiUrl, saveAndValidateWebsiteApiResponse } from './../../shared/utils/environment.js';
import { GlobalErrorContext } from './../../shared/context/GlobalErrorContext.js';
import { GlobalUserContext } from '../../shared/context/GlobalUserContext.js';
import { GlobalAppointmentContext } from '../../shared/context/GlobalAppointment.js';
import { GlobalIsRegisteredContext } from '../../shared/context/GlobalIsRegistered.js';
import { GlobalIsBlockedContext } from '../../shared/context/GlobalIsBlocked.js';

import Header from '../Header/Header';
import Booking from '../Booking/Booking';
import Profile from '../Profile/Profile';
import Chat from '../Chat/Chat';
import Login from '../Login/Login';
import Logout from '../Logout/Logout';
import ConfirmAppointment from '../ConfirmAppointment/ConfirmAppointment';

import Loader from '../Loader/Loader';
import Error from '../Error/Error';

import './../../assets/styles/main.scss';

export default function App() {

  const {isGlobalError, setGlobalError} = useContext(GlobalErrorContext);
  const {setGlobalUser} = useContext(GlobalUserContext);
  const {getGlobalAppointment, setGlobalAppointment} = useContext(GlobalAppointmentContext);
  const {setGlobalIsRegistered} = useContext(GlobalIsRegisteredContext);
  const {getGlobalIsBlocked, setGlobalIsBlocked} = useContext(GlobalIsBlockedContext);

  const [initialLoading, setInitialLoading] = useState(true);

  // runs only on mount
  useEffect(() => {

    (async () => {

      let isLoggedIn = false;

      /**
       * 1. Get data from WP
       */
      try {
        const response = await axios.get(getWebsiteApiUrl());
        const isValid = saveAndValidateWebsiteApiResponse(response);
        setGlobalError({
          isError: !isValid,
          errorCode: 'WP101'
        });
      } catch(err) {
        console.error(err);
        setGlobalError({
          isError: true,
          errorCode: 'WP101'
        });
      }

      /**
       * 2. Get user status
       */
      try {
        const user_data = await fetchLoginStatus();
        if (user_data === false) {
          setGlobalError({
            isError: true,
            errorCode: 'AU101'
          });
        } else if (user_data.is_authenticated) {
          setGlobalUser({
            "isLoggedIn": user_data.is_authenticated,
            "givenName": user_data.given_name,
            "lastName": user_data.last_name,
            "personId": user_data.person_id
          });
          isLoggedIn = true;
        }

      } catch(err) {
        console.error(err);
        setGlobalError({
          isError: true,
          errorCode: 'AU101'
        });
      }

      /**
       * 3. Check if user is registered or blocked
       */
      if (isLoggedIn) {
        try {
          const client = await findClient();
          if (client.client_path) {
            setGlobalIsRegistered(true);
          } else {
            setGlobalIsRegistered(false);
          }
          if (client.isReservationBlocked) {
            setGlobalIsBlocked(true);
          } else {
            setGlobalIsBlocked(false);
          }
        } catch(err) {
          setGlobalIsRegistered(false);
        }
      }

      /**
       * 4. Set initial state from memory
       */

      // booking in progress (user returns from authentication)
      if (window.sessionStorage.getItem('oa-booking-confirmation') && !getGlobalIsBlocked) {
        setGlobalAppointment(JSON.parse(window.sessionStorage.getItem('oa-booking-confirmation')));
      } else if (isLoggedIn) {

      }

      setInitialLoading(false);
    })();

  }, []);

  return (



  <div className="app">


    {initialLoading && !isGlobalError.isError ? <>
      <div className="app__content">
        <Loader />
      </div>
    </> : ''}
    {isGlobalError.isError && !initialLoading ? <>
      <div className="app__content">
        <Error />
      </div>
    </> : ''}

    {!initialLoading && !isGlobalError.isError ? <>

      <HashRouter>
      <Header />
        <div className="app__content">
          <Switch>
            <Route exact path="/">
              <Booking />
            </Route>
            <Route exact path="/profile">
              <Profile />
            </Route>
            <Route exact path="/chat">
              <Chat />
            </Route>
            <Route exact path="/login">
              <Login />
            </Route>
            <Route exact path="/logout">
              <Logout />
            </Route>
          </Switch>
        </div>

      </HashRouter>

      {getGlobalAppointment.hasConfirmation && !getGlobalIsBlocked ? <ConfirmAppointment /> : ''}

    </> : ''}

  </div>

  )

}
